export enum RoleType {
   User = 'User', // regular / field role
   Admin = 'Admin',
   SuperAdmin = 'SuperAdmin',
}

/**
 * Only the regular field role needs the Apollo cache persisted to
 * IndexedDB for offline use. Admin/SuperAdmin are office-based and
 * always online, so their sessions stay in-memory-only — no reason
 * to pay the persistence overhead or grow IndexedDB for them.
 */
export function isFieldRole(role: RoleType): boolean {
   return role === RoleType.User;
}

/**
 * Admin and SuperAdmin are the two office/back-office roles that get
 * elevated permissions in admin-facing forms (e.g. backdating a daily
 * report). Field (User) role never does.
 */
export function isAdminOrSuperAdmin(role: RoleType): boolean {
   return role === RoleType.Admin || role === RoleType.SuperAdmin;
}
